import { ReactElement } from 'react';
import { Subtext } from '../../models/product.types';

type FormattedTextProps = {
  text: Subtext[];
  hyperlinkUrl?: string;
};

export function FormattedText({
  text,
  hyperlinkUrl,
}: FormattedTextProps): ReactElement {
  return (
    <>
      {text.map((elem, i) => {
        if (elem.paragraph) {
          return <p key={i}>{elem.paragraph}</p>;
        }
        if (elem.italic) {
          return (
            <span key={i}>
              {hyperlinkUrl ? (
                <a href={hyperlinkUrl} target="_blank" rel="noopener noreferrer">
                  <i>{elem.italic}</i>
                </a>
              ) : (
                <i>{elem.italic}</i>
              )}
            </span>
          );
        }
        if (elem.superscript) {
          return (
            <span key={i}>
              <sup>{elem.superscript}</sup>
            </span>
          );
        }
        if (elem.bold) {
          return <strong key={i}>{elem.bold}</strong>;
        }
        if (elem.regular) {
          return <span key={i}>{elem.regular}</span>;
        }
        if (elem.list) {
          return (
            <ul key={i} style={{ marginBottom: '0rem' }}>
              {elem.list.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          );
        }
        return null;
      })}
    </>
  );
}
